import React, { useEffect, useMemo, useState } from 'react';

import {
    makeStyles,
    Paper,
    Grid,
    Tabs,
    Tab,
    Container,
    Button,
    Box,
    RadioGroup,
    FormControlLabel,
    Radio,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    CircularProgress,
    Icon,
} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import Summary from 'app/internalPages/Summary';
import Request from './components/Request';
import Revisions from './components/Revisions';

import { injectIntl, FormattedMessage } from 'react-intl';

import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';

import { clearFiles, clearCity } from 'app/store/slices/forms';
import { clearServiceDetails, clearServiceDocuments } from 'app/store/slices/services';
import { clearNewRequest, clearRequestDetails, updateRequestDetails } from 'app/store/slices/requests';
import {
    clearRevisions,
    clearActualRevision,
    fecthAllRevisions,
    fecthActualRevision,
} from 'app/store/slices/revisions';
import { showLoading, hideLoading } from 'app/store/slices/settings';
import requestEndpoints from 'app/api/services/requestEndpoints';

import notification from 'app/config/notification';
import certificationEndpoints from 'app/api/services/certificationEndpoints';
import ConfirmDialog from 'app/components/ConfirmDialog';
import Alert from '@material-ui/lab/Alert';
import { errorHandler } from 'app/utils/errorHandler';
import surveyEndpoint from 'app/api/services/surveyEndpoint';
import Survey from './components/Survey';

import VehicleCertification from './components/Certification/VehicleCertification';
import LicenseCertification from './components/Certification/LicenseCertification';
import CompanyCertification from './components/Certification/CompanyCertification';

import { SERVICES_CODES, SERVICES_GROUPS, SERVICES_PROPERTIES } from 'app/config/services';
import { STATUS_CODES } from 'app/config/status';
import { INTERNAL_CONTEXT } from 'app/config/urls';

import Documentation from './components/Documentation';

import styles from './styles';
import { prepareStore } from './components/Documentation/functions/revisions';
import LineCertification from './components/Certification/LineCertification';

const useStyles = makeStyles(styles);

function RequestDetails(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const { intl } = props;

    const cdSolicitacao = props.match?.params?.cdSolicitacao;
    const request = useSelector((state) => state.requests.details);
    const revisions = useSelector((state) => state.revisions.revisions);
    const actualRevision = useSelector((state) => state.revisions.details);
    const documentsStore = useSelector((state) => state.services.documents);
    const documentsStoreVehicle = useSelector((state) => state.vehicle.licenseVehicleDocuments);

    const [textConfirmDialog, setTextConfirmDialog] = useState('');
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [filesStore, setFilesStore] = useState([]);

    const certificateTabTitle = useMemo(() => {
        if (SERVICES_PROPERTIES[request.cdServico] && SERVICES_PROPERTIES[request.cdServico].certificateTabTitle) {
            return SERVICES_PROPERTIES[request.cdServico].certificateTabTitle;
        }
        return 'Certificados';
    }, [request.cdServico]);

    const [openDialogJustification, setOpenDialogJustification] = useState(false);
    const [justification, setJustification] = useState('');
    const [valueMainTab, setValueMainTab] = useState(0);
    const [situation, setSituation] = useState(() => {
        switch (request?.cdSituacao) {
            case 5:
                return 'aprovado';
            case 6:
                return 'reprovado';
            case 7:
                return 'cancelado';
            default:
                return null;
        }
    });

    const hasApprove = useMemo(() => {
        return true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request.cdServico]);

    const hasSendSurveyBtn = useMemo(() => {
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request]);

    useEffect(() => {
        const init = async () => {
            if (!cdSolicitacao) return <Redirect to={INTERNAL_CONTEXT} />;
            try {
                const response = await requestEndpoints.findRequest({ cdSolicitacao }, '');
                if (response?.status === 200 && response?.data) {
                    await dispatch(updateRequestDetails(response.data));
                }
            } catch (error) {}
        };
        init();
        // eslint-disable-next-line
    }, []);

    const hasDocumentation = useMemo(() => {
        return !(
            request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO ||
            request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO
        );
    }, [request]);

    const cdServico = useMemo(() => {
        return request.cdServico;
    }, [request]);

    const hideFinalizeBtn = useMemo(() => {
        return (
            request.cdSituacao === STATUS_CODES.APROVADO ||
            request.cdSituacao === STATUS_CODES.REPROVADO ||
            request.cdSituacao === STATUS_CODES.CANCELADO
        );
    }, [request.cdSituacao]);

    const hasCertification = useMemo(() => {
        if (request.cdServico === SERVICES_CODES.VISTORIA && request.cdSituacao !== STATUS_CODES.EM_CONSTRUCAO) {
            return true;
        }
        if (
            request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO ||
            request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO
        ) {
            return false;
        }
        return SERVICES_PROPERTIES[cdServico]?.hasCertification;
    }, [cdServico, request.cdServico, request.cdSituacao]);

    const [numSurveyCertificates, setNumSurveyCertificates] = useState(null);

    const hasSurvey = useMemo(() => {
        if (request.cdServico === SERVICES_CODES.VISTORIA) {
            return false;
        }
        if (
            request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO ||
            request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO
        ) {
            return false;
        }
        return SERVICES_PROPERTIES[cdServico]?.hasSurvey;
    }, [cdServico, request.cdServico, request.cdSituacao]);

    const hasRevisions = useMemo(() => {
        return SERVICES_PROPERTIES[cdServico]?.hasRevisions;
    }, [cdServico]);

    const viewsRequest = 0;
    const viewsDocumentation = 1;

    const viewsCertificates = useMemo(() => {
        let numView = viewsRequest;
        if (hasDocumentation) numView = numView + 1;
        if (hasCertification) numView = numView + 1;
        return numView;
    }, [hasCertification, hasDocumentation, viewsRequest]);

    const viewsRevisions = useMemo(() => {
        let numView = viewsRequest;
        if (hasDocumentation) numView = numView + 1;
        if (hasCertification) numView = numView + 1;
        if (hasRevisions) numView = numView + 1;
        return numView;
    }, [hasCertification, hasDocumentation, hasRevisions, viewsRequest]);

    const viewsSurvey = useMemo(() => {
        let numView = viewsRequest;
        if (hasDocumentation) numView = numView + 1;
        if (hasCertification) numView = numView + 1;
        if (hasRevisions) numView = numView + 1;
        if (hasSurvey) numView = numView + 1;
        return numView;
    }, [hasCertification, hasDocumentation, hasRevisions, hasSurvey, viewsRequest]);

    useEffect(() => {
        const init = () => {
            const fileStoreResult = prepareStore(
                request,
                documentsStore,
                documentsStoreVehicle,
                revisions,
                actualRevision,
            );
            setFilesStore(fileStoreResult);
        };
        init();
    }, [actualRevision, documentsStore, documentsStoreVehicle, request, revisions]);

    useEffect(() => {
        const init = async () => {
            dispatch(showLoading());
            if (request.cdSituacao !== STATUS_CODES.EM_CONSTRUCAO && request.cdSolicitacao) {
                const promisses = [dispatch(fecthActualRevision(request.cdSolicitacao, ''))];
                promisses.push(dispatch(fecthAllRevisions(request.cdSolicitacao, '')));
                await Promise.all(promisses);
            }
            if (request.cdSituacao === STATUS_CODES.AGUARDANDO_AJUSTES_DOCUMENTO) {
                if (request.deJustificativa && request.deJustificativa !== '') {
                    setAlertMessage(request.deJustificativa);
                }
            }
            dispatch(hideLoading());
        };
        init();
    }, [dispatch, request]);

    useEffect(() => {
        return () => {
            dispatch(clearCity());
            dispatch(clearFiles());
            dispatch(clearServiceDetails());
            dispatch(clearServiceDocuments());
            dispatch(clearNewRequest());
            dispatch(clearRequestDetails());
            dispatch(clearRevisions());
            dispatch(clearActualRevision());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeMainTab = (event, newValue) => {
        setTextConfirmDialog('As informações não salvas serão perdidas.');
        setValueMainTab(newValue);
    };

    const handleChangeSituation = (event) => {
        setSituation(event.target.value);
    };

    const handleCloseDialogJustification = () => {
        setJustification('');
        setOpenDialogJustification(false);
    };

    const handleOpenDialogJustification = () => {
        setJustification('');
        setOpenDialogJustification(true);
    };

    const validateDocuments = () => {
        const jsonData = request.jsonSolicitacao ? JSON.parse(request.jsonSolicitacao) : {};
        if (SERVICES_GROUPS.COMPANY.includes(request.cdServico) && !jsonData.documentos) return false;
        let errors = 0; //must start at 0
        let serviceDocuments = [];
        if (filesStore.length > 0) {
            const documentsToRevision = filesStore[filesStore.length - 1];
            documentsToRevision.forEach((docRev) => {
                const docs = docRev.documents || [];
                serviceDocuments = [...serviceDocuments, ...docs];
            });
        }
        serviceDocuments.forEach((doc) => {
            if (doc.boDocumentoObrigatorio && !doc.idFile) {
                errors++;
                return;
            }
            if (doc.idFile && (!doc.boConformidade || doc.boConformidade === 'false' || doc.boConformidade === '')) {
                errors++;
            }
        });
        return errors === 0;
    };

    const handleStatusRequest = async () => {
        if (justification === '') {
            notification(intl.formatMessage({ id: 'MESSAGES.REQUEST.REASON_MANDATORY' }), {
                toastId: 'REASON_MANDATORY',
                type: 'warning',
            });
            return;
        }
        dispatch(showLoading());
        const sendingData = new FormData();
        sendingData.append('cdSolicitacao', request.cdSolicitacao);
        sendingData.append('deJustificativa', justification);
        // eslint-disable-next-line default-case
        switch (situation) {
            case 'reprovado':
                try {
                    setOpenDialogJustification(false);
                    const response = await requestEndpoints.disapproveRequest(request.cdSolicitacao, sendingData);
                    if (response?.status === 200) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SUCCESSFUL_REPROVE_REQUEST' }), {
                            toastId: 'SUCCESSFUL_REPROVE_REQUEST',
                            type: 'success',
                        });
                        history.push(INTERNAL_CONTEXT);
                    }
                } catch (error) {
                    errorHandler(error.response?.status, error.response?.data?.message);
                }
                dispatch(hideLoading());
                break;
            case 'cancelado':
                try {
                    setOpenDialogJustification(false);
                    const response = await requestEndpoints.cancelRequest(request.cdSolicitacao, sendingData, '');
                    if (response?.status === 200) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SUCCESSFUL_CANCEL_REQUEST' }), {
                            toastId: 'SUCCESSFUL_CANCEL_REQUEST',
                            type: 'success',
                        });
                        history.push(INTERNAL_CONTEXT);
                    }
                } catch (error) {
                    errorHandler(error.response?.status, error.response?.data?.message);
                }
                dispatch(hideLoading());
                return;
        }
        handleCloseDialogJustification();
    };

    const handleFinalize = async () => {
        if (!situation) {
            notification(intl.formatMessage({ id: 'MESSAGES.REQUEST.STATUS_REQUEST_MANDATORY' }), {
                toastId: 'STATUS_REQUEST_MANDATORY',
                type: 'warning',
            });
            return;
        }
        const jsonData = request.jsonSolicitacao ? JSON.parse(request.jsonSolicitacao) : {};

        let serviceCode = request.cdServico;
        if (jsonData.cdServicoOrigem) {
            serviceCode = jsonData.cdServicoOrigem;
        }

        switch (situation) {
            case 'aprovado':
                dispatch(showLoading());

                let canApprove = true;
                let cdCertificado = null;
                let hasCertificate = false;
                let numCertificates = 0;
                if (
                    SERVICES_GROUPS.COMPANY.includes(request.cdServico) ||
                    SERVICES_GROUPS.LICENSE.includes(request.cdServico) ||
                    SERVICES_GROUPS.LINES_STRIP.includes(request.cdServico) ||
                    SERVICES_CODES.VISTORIA === request.cdServico
                ) {
                    canApprove = false;
                    const response = await certificationEndpoints.getCertificates(request.cdSolicitacao);
                    numCertificates = response.data?.length || 0;
                    if (response.status === 200 && response.data && response.data.length > 0) {
                        hasCertificate = true;
                        const certificates = response.data;
                        let assignOk = true;
                        if (STATUS_CODES.RETORNO_DIRETOR_GERAL === request.cdSituacao) {
                            certificates.forEach((cert) => {
                                if (!cert.boAssinado) assignOk = false;
                            });
                        } else if (
                            serviceCode !== SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL &&
                            serviceCode !== SERVICES_CODES.VISTORIA
                        ) {
                            certificates.forEach((cert) => {
                                if (!cert.boAssinado) assignOk = false;
                            });
                        } else {
                            if (certificates[0] && certificates[0].cdCertificado) {
                                cdCertificado = certificates[0].cdCertificado;
                            }
                        }
                        canApprove = assignOk;
                    }
                }

                let error = false;
                if (SERVICES_CODES.VISTORIA === cdServico) {
                    if (numSurveyCertificates === null || numCertificates < numSurveyCertificates) {
                        notification(
                            intl.formatMessage({ id: 'MESSAGES.SERVICE.WRONG_CHOICE_MISSING_SURVEY_CERTIFICATE' }),
                            {
                                toastId: 'WRONG_CHOICE_MISSING_SURVEY_CERTIFICATE',
                                type: 'warning',
                            },
                        );
                        error = true;
                    }
                } else if (
                    SERVICES_PROPERTIES[cdServico].needDocumentToApprove &&
                    STATUS_CODES.RETORNO_DIRETOR_GERAL !== request.cdSituacao
                ) {
                    if (!hasCertificate) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.WRONG_CHOICE_MISSING_CERTIFICATE' }), {
                            toastId: 'WRONG_CHOICE_MISSING_CERTIFICATE',
                            type: 'warning',
                        });
                        error = true;
                    } else if (!canApprove) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.WRONG_CHOICE_TO_SERVICE_TYPE' }), {
                            toastId: 'WRONG_CHOICE_TO_SERVICE_TYPE',
                            type: 'warning',
                        });
                        error = true;
                    }
                }

                if (!error) {
                    const documentsOK = validateDocuments();
                    if (!documentsOK) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.MISSING_DOCUMENTS_TO_APPROVE' }), {
                            toastId: 'MISSING_DOCUMENTS_TO_APPROVE',
                            type: 'warning',
                        });
                        dispatch(hideLoading());
                        return;
                    }

                    try {
                        const response = await requestEndpoints.approveRequest({ request, cdCertificado });
                        if (response?.status === 200) {
                            notification(
                                intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SUCCESSFUL_APROVE_REQUEST' }),
                                {
                                    toastId: 'SUCCESSFUL_APROVE_REQUEST',
                                    type: 'success',
                                },
                            );
                            history.push(INTERNAL_CONTEXT);
                        }
                    } catch (error) {
                        errorHandler(error.response?.status, error.response?.data?.message);
                    }
                }
                dispatch(hideLoading());
                return;
            case 'reprovado':
                handleOpenDialogJustification();
                return;
            case 'cancelado':
                handleOpenDialogJustification();
                return;

            default:
                break;
        }
        dispatch(clearRequestDetails());
        history.push(INTERNAL_CONTEXT);
    };

    if (Object.keys(request).length === 0) {
        return (
            <div className={classes.centerProgress}>
                <CircularProgress size={20} />
            </div>
        );
    }

    const handleSendSurvey = async () => {
        dispatch(showLoading());
        try {
            const documentsOK = validateDocuments();
            if (!documentsOK) {
                notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.MISSING_DOCUMENTS_TO_APPROVE' }), {
                    toastId: 'MISSING_DOCUMENTS_TO_APPROVE',
                    type: 'warning',
                });
                dispatch(hideLoading());
                return;
            }
            const response = await surveyEndpoint.sendSurvey(request.cdSolicitacao);
            if (response.status === 200) {
                notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SUCCESSFUL_SEND_SURVEY_REQUEST' }), {
                    toastId: 'SUCCESSFUL_SEND_SURVEY_REQUEST',
                    type: 'success',
                });
                dispatch(clearRequestDetails());
                history.push(INTERNAL_CONTEXT);
            }
        } catch (error) {
            console.error(error);
        }
        dispatch(hideLoading());
    };

    const renderDialogJustification = () => {
        return (
            <Dialog
                open={openDialogJustification}
                onClose={handleCloseDialogJustification}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    {situation === 'cancelado' ? 'Cancelamento' : 'Reprovação'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>Favor preencher a justificativa abaixo.</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label=""
                        fullWidth
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                        inputProps={{
                            maxLength: 490,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogJustification} color="primary">
                        Fechar
                    </Button>
                    <Button onClick={() => handleStatusRequest()} color="primary">
                        Enviar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    return (
        <>
            <ConfirmDialog
                title={'Deseja continuar?'}
                text={textConfirmDialog}
                open={openConfirmDialog}
                handleClose={() => setOpenConfirmDialog(false)}
                // handleClickNo={}
                // handleClickYes ={}
            />
            <Container className={classes.container}>
                {renderDialogJustification()}
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Summary />
                    </Grid>

                    <Grid item xs={12}>
                        <Paper>
                            <Container>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Tabs
                                            value={valueMainTab}
                                            indicatorColor="secondary"
                                            textColor="secondary"
                                            onChange={handleChangeMainTab}
                                            centered
                                            className={classes.mainTabs}>
                                            <Tab
                                                wrapped
                                                className={classes.tabMainsTab}
                                                label={
                                                    <div className={classes.labelMainTab}>
                                                        <div>Solicitação</div>{' '}
                                                        {valueMainTab === 0 && <ExpandLessIcon color="secondary" />}
                                                    </div>
                                                }
                                            />
                                            {hasDocumentation && (
                                                <Tab
                                                    wrapped
                                                    className={classes.tabMainsTab}
                                                    label={
                                                        <div className={classes.labelMainTab}>
                                                            <div>Documentação e Pendências</div>{' '}
                                                            {valueMainTab === 1 && <ExpandLessIcon color="secondary" />}
                                                        </div>
                                                    }
                                                />
                                            )}
                                            {hasCertification && (
                                                <Tab
                                                    wrapped
                                                    className={classes.tabMainsTab}
                                                    label={
                                                        <div className={classes.labelMainTab}>
                                                            <div>{certificateTabTitle}</div>{' '}
                                                            {valueMainTab === 2 && <ExpandLessIcon color="secondary" />}
                                                        </div>
                                                    }
                                                />
                                            )}
                                            {hasRevisions && (
                                                <Tab
                                                    wrapped
                                                    className={classes.tabMainsTab}
                                                    label={
                                                        <div className={classes.labelMainTab}>
                                                            <div>Revisões</div>{' '}
                                                            {valueMainTab === 3 && <ExpandLessIcon color="secondary" />}
                                                        </div>
                                                    }
                                                />
                                            )}
                                            {hasSurvey && (
                                                <Tab
                                                    wrapped
                                                    className={classes.tabMainsTab}
                                                    label={
                                                        <div className={classes.labelMainTab}>
                                                            <div>Dados da vistoria</div>{' '}
                                                            {valueMainTab === 4 && <ExpandLessIcon color="secondary" />}
                                                        </div>
                                                    }
                                                />
                                            )}
                                        </Tabs>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    {alertMessage && alertMessage !== '' && (
                                        <Grid item xs={12}>
                                            <Alert severity="warning">
                                                {request.situacao?.deSituacao}: {alertMessage}
                                            </Alert>
                                        </Grid>
                                    )}
                                    <Grid item xs={12}>
                                        <Container className={classes.containerForm}>
                                            {valueMainTab === viewsRequest && <Request />}
                                            {hasDocumentation && valueMainTab === viewsDocumentation && (
                                                <Documentation filesStore={filesStore} />
                                            )}
                                            {hasCertification && valueMainTab === viewsCertificates && (
                                                <>
                                                    {SERVICES_GROUPS.COMPANY.includes(request.cdServico) && (
                                                        <CompanyCertification validateDocuments={validateDocuments} />
                                                    )}
                                                    {SERVICES_GROUPS.SURVEY.includes(request.cdServico) && (
                                                        <VehicleCertification
                                                            validateDocuments={validateDocuments}
                                                            setNumCertificates={setNumSurveyCertificates}
                                                        />
                                                    )}
                                                    {SERVICES_GROUPS.LICENSE.includes(request.cdServico) && (
                                                        <LicenseCertification validateDocuments={validateDocuments} />
                                                    )}
                                                    {(SERVICES_GROUPS.LINES_SLIC.includes(request.cdServico) ||
                                                        SERVICES_GROUPS.LINES_STRIP.includes(request.cdServico)) && (
                                                        <LineCertification validateDocuments={validateDocuments} />
                                                    )}
                                                </>
                                            )}
                                            {hasRevisions && valueMainTab === viewsRevisions && <Revisions />}
                                            {hasSurvey && valueMainTab === viewsSurvey && <Survey />}

                                            {!hideFinalizeBtn && (
                                                <Grid container spacing={3} className={classes.finalizeContainer}>
                                                    <RadioGroup
                                                        row
                                                        aria-label="position"
                                                        name="position"
                                                        onChange={handleChangeSituation}
                                                        value={situation}>
                                                        {hasApprove && (
                                                            <FormControlLabel
                                                                value="aprovado"
                                                                control={<Radio color="secondary" />}
                                                                label="Aprovado"
                                                            />
                                                        )}
                                                        <FormControlLabel
                                                            value="reprovado"
                                                            control={<Radio color="secondary" />}
                                                            label="Reprovado"
                                                        />
                                                        <FormControlLabel
                                                            value="cancelado"
                                                            control={<Radio color="secondary" />}
                                                            label="Cancelado"
                                                        />
                                                    </RadioGroup>

                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        className={classes.finalizeBtn}
                                                        type="button"
                                                        disableElevation
                                                        onClick={() => handleFinalize()}>
                                                        <Box className={classes.colorWhite}>
                                                            <FormattedMessage id="LABELS.SERVICES.FINALIZE_REQUEST" />
                                                        </Box>
                                                    </Button>

                                                    {hasSendSurveyBtn && (
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            type="button"
                                                            disableElevation
                                                            className={classes.sendSurvey}
                                                            endIcon={<Icon>send</Icon>}
                                                            onClick={() => handleSendSurvey()}>
                                                            <FormattedMessage id="LABELS.SERVICES.SEND_TO_SURVEYOR" />
                                                        </Button>
                                                    )}
                                                </Grid>
                                            )}
                                        </Container>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default injectIntl(RequestDetails);
